import { useCallback, useEffect, useState } from "react";
import { useApi } from "../../api";
import { AppHeader } from "../../components/AppHeader";
import { ICargo, IFavorite } from "../../interfaces";

export const FavoriteCryptoPage = () => {
  const api = useApi('SAI');
  const [mounted, setMounted] = useState<Boolean>(false);
  const [favorites, setFavorites] = useState<IFavorite[]>([]);

  const fetchFavoriteCryptos = useCallback(() => {
    api.getFavoriteCryptos((cargo: ICargo) => {
      if (cargo.returnCode === '000000') {
        setFavorites(cargo.info);
      }
    })
  }, [api])

  useEffect(() => {
    if (mounted) return;
    setMounted(true);
    fetchFavoriteCryptos()
  }, [fetchFavoriteCryptos, mounted])

  return (
    <>
      <AppHeader title="我的最愛"></AppHeader>
      <div className="bg-white p-3">
        {
          favorites.map((favorite, index) => {
            return (
              <>
                <div className="flex justify-between border-b border-b-gray-300 pb-2 mb-3 text-cyan-700">
                  <div>
                    <div className="flex flex-wrap ">
                      <div>
                        <img
                          className="w-16 h-16 bg-slate-300 rounded-full"
                          src={`https://ai.supercoin.network/img/coin/${favorite.item}.png`}
                          alt={`${favorite.item}`}
                        />
                      </div>
                      <div className="p-3">{favorite.item}</div>
                    </div>
                  </div>
                  <div className="p-1 cursor-pointer" onClick={() => {
                    api.removeCryptoFavorite(favorite.item, (cargo: ICargo) => {
                      if (cargo.returnCode === '000000') {
                        fetchFavoriteCryptos()
                      }
                    })
                  }}>移除</div>
                </div>
              </>
            )
          })
        }
      </div>
    </>
  )
}
